export const isRasterOwner = (ownerId) => {
    return RASTER_OWNERS.includes(ownerId);
};

export const isRasterNode = (node) => {
    return node?.data?.sourceType === 'WMS' || node?.data?.sourceType === 'WMTS';
};

/**
 * Hard coded owners currently. This is fine because the owner IDs don't change, and no-one else is expected to supply raster data.
 *
 * @type {string[]}
 */
const RASTER_OWNERS = [
    '64f1d9f4-d243-4211-8da3-caa310bcba58',
    '849cd700-d027-4251-ae8c-a0f2a35dc7cf',
    'a952b3e0-a20d-41c6-82e7-447db7d5c98e',
    'f8de258d-4598-4d98-be0d-fd369a6c73b1'
];
